import { TextField } from '@mui/material';
import React, { ChangeEvent, FC, useEffect, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';

interface IDebouncedTextInputProps {
  setDebouncedState?: (state: string) => void;
  delay?: number;
  placeholder?: string;
  inputProps?: object;
  value?: string | null;
  className?: string;
  disabled?: boolean;
}

const DebouncedTextInput: FC<IDebouncedTextInputProps> = ({
  value,
  delay = 250,
  placeholder = 'Search for products',
  inputProps,
  className,
  disabled = false,
  setDebouncedState,
}) => {
  const [_value, setValue] = useState(value);

  useEffect(() => {
    setValue(value);
  }, [value]);

  const debouncedFunction = useDebouncedCallback(state => {
    setDebouncedState?.(state);
  }, delay);

  const onChangeInput = (e: ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
    debouncedFunction.callback(e.target.value);
  };

  return (
    <TextField
      size="small"
      variant="outlined"
      value={_value || ''}
      className={className}
      placeholder={placeholder}
      onChange={onChangeInput}
      InputProps={inputProps}
      disabled={disabled}
    />
  );
};

export default DebouncedTextInput;
